import Api from "../../utils/axios"; // Use the configured axios instance

const DeliveryInfoApi = {
  // Fetch all delivery info
  getAllDeliveryInfo: () => Api.get("master/get-all-business-type"),

  // Add a new delivery
  addDelivery: (payload) =>
    Api.post("master/create-business-type", payload, {
      header: { "content-type": "multipart/formdata" },
    }), // Update the endpoint based on your backend

  // Fetch individual delivery info by ID
  getIndividualDeliveryInfo: (id) => Api.get(`master/get-business-type/${id}`),

  // Update delivery info by ID
  updateIndividualDeliveryInfo: (id, payload) =>
    Api.put(`master/update-business-type/${id}`, payload, {
      header: { "content-type": "multipart/formdata" },
    }),

  // Delete delivery info by ID
  deleteIndividualDeliveryInfo: (id) =>
    Api.delete(`master/delete-business-type/${id}`),
};

export default DeliveryInfoApi;
